class ImageComparison extends HTMLElement {
  constructor() {
    super();
    this.dragging = false;
    this.horizontal = this.dataset.layout === 'horizontal';
    this.handle = this.querySelector('.image-comparison__button');

    if (!this.handle) return;

    this.handle.addEventListener('pointerdown', this.startDragging.bind(this));
    this.handle.addEventListener('pointermove', this.drag.bind(this));
    this.handle.addEventListener('pointerup', this.stopDragging.bind(this));
    this.handle.addEventListener('pointercancel', this.stopDragging.bind(this));
    this.handle.addEventListener('keydown', this.handleKeydown.bind(this));

    this.revealWhenVisible();
  }

  revealWhenVisible() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.setAttribute('animate', '');
        this.classList.add('animating');
        window.setTimeout(() => this.classList.remove('animating'), 1000);
        observer.disconnect();
      },
      { threshold: 0.1 }
    );

    observer.observe(this);
  }

  startDragging(event) {
    this.dragging = true;
    this.classList.add('scrolling');
    this.handle.setPointerCapture(event.pointerId);
    this.updateFromPointer(event);
  }

  drag(event) {
    if (!this.dragging) return;
    this.updateFromPointer(event);
  }

  stopDragging(event) {
    if (!this.dragging) return;
    this.dragging = false;
    this.classList.remove('scrolling');

    if (this.handle.hasPointerCapture(event.pointerId)) {
      this.handle.releasePointerCapture(event.pointerId);
    }
  }

  updateFromPointer(event) {
    const bounds = this.getBoundingClientRect();
    const distance = this.horizontal ? event.clientX - bounds.left : event.clientY - bounds.top;
    const total = this.horizontal ? bounds.width : bounds.height;
    this.setPosition((distance / total) * 100);
  }

  handleKeydown(event) {
    const backward = this.horizontal ? event.key === 'ArrowLeft' : event.key === 'ArrowUp';
    const forward = this.horizontal ? event.key === 'ArrowRight' : event.key === 'ArrowDown';

    if (!backward && !forward && event.key !== 'Home' && event.key !== 'End') return;

    event.preventDefault();
    const current = Number.parseFloat(this.style.getPropertyValue('--percent')) || 50;
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? 100 : current + (forward ? 2 : -2);
    this.setPosition(next);
  }

  setPosition(position) {
    const clamped = Math.min(98, Math.max(2, position));
    this.style.setProperty('--percent', `${clamped}%`);
    this.handle.setAttribute('aria-valuenow', String(Math.round(clamped)));
  }
}

if (!customElements.get('image-comparison')) {
  customElements.define('image-comparison', ImageComparison);
}
